


// import React, { useState } from "react";
// import styles from "../../assets/scss/HelpCenterNormalUser/AddIssuePopup.module.scss";
// import { toast } from "react-toastify";
// import { useCreateEnquiryIssueMutation } from "../../slices/admin/admin";

// const AddIssuePopup = ({ onClose }) => {
//   const [issue, setIssue] = useState("");
//   const [description, setDescription] = useState("");
//   const [error, setError] = useState("");

//   const [createEnquiryIssue, { isLoading }] =
//     useCreateEnquiryIssueMutation();

//   const handleSubmit = async () => {
//     if (!issue.trim()) {
//       setError("Issue name is required");
//       toast.error("Issue name is required");
//       return;
//     }

//     try {
//       await createEnquiryIssue({
//         issueName: issue,
//         description: description || "", // ✅ optional
//       }).unwrap();

//       toast.success("Issue Added Successfully");
//       onClose();
//     } catch (err) {
//       toast.error(err?.data?.message || "Failed to add issue");
//     }
//   };

//   return (
//     <div className={styles.popupForm}>
//       <div className={styles.header}>
//         <h2 className={styles.tittle}>Add Issue</h2>
//         <span className={styles.closeIcons} onClick={onClose}>
//           X
//         </span>
//       </div>

//       <div className={styles.closeIcon}>
//         {/* Issue Name */}
//         <div className={styles.inputGroup}>
//           <label className={styles.inputLabel}>
//             Issue Name <span className={styles.required}>*</span>
//           </label>
//           <input
//             className={styles.input}
//             type="text"
//             placeholder="Login issue"
//             value={issue}
//             onChange={(e) => {
//               setIssue(e.target.value);
//               setError("");
//             }}
//           />
//           {error && <span className={styles.error}>{error}</span>}
//         </div>

//         {/* Description (Optional) */}
//         <div className={styles.inputGroup}>
//           <label className={styles.inputLabel}>
//             Description <span className={styles.optional}>(Optional)</span>
//           </label>
//           <textarea
//             className={styles.textarea}
//             placeholder="Describe the issue (optional)"
//             value={description}
//             onChange={(e) => setDescription(e.target.value)}
//           />
//         </div>

//         <div className={styles.footerButtons}>
//           <button
//             className={styles.cancel}
//             onClick={onClose}
//             disabled={isLoading}
//           >
//             Cancel
//           </button>

//           <button
//             className={styles.save}
//             onClick={handleSubmit}
//             disabled={isLoading}
//           >
//             {isLoading ? "Adding..." : "Add"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddIssuePopup;

import React, { useState, useEffect } from "react";
import styles from "../../assets/scss/HelpCenterNormalUser/AddIssuePopup.module.scss";
import { toast } from "react-toastify";
import {
    useCreateEnquiryIssueMutation,
    useUpdateEnquiryIssueMutation,
} from "../../slices/admin/admin";

const AddIssuePopup = ({ onClose, editData }) => {
    const [issue, setIssue] = useState("");
    const [description, setDescription] = useState("");
    const [error, setError] = useState("");

    const [createEnquiryIssue, { isLoading: creating }] =
        useCreateEnquiryIssueMutation();

    const [updateEnquiryIssue, { isLoading: updating }] =
        useUpdateEnquiryIssueMutation();

    /* PREFILL DATA WHEN EDIT */
    useEffect(() => {
        if (editData) {
            setIssue(editData.issueName || "");
            setDescription(editData.description || "");
        }
    }, [editData]);
    useEffect(() => {
        if (!editData) {
            setIssue("");
            setDescription("");
            setError("");
        }
    }, [editData]);

    const handleSubmit = async () => {
        //alert("This feature is under development. Please check back later.");
        if (!issue.trim()) {
            setError("Issue name is required");
            toast.error("Issue name is required");
            return;
        }

        try {
            if (editData?._id) {
                // ✅ UPDATE API
                await updateEnquiryIssue({
                    id: editData._id,
                    body: {
                        issueName: issue.trim(),
                        description: description.trim(),
                    },
                }).unwrap();

                toast.success("Enquiry Issue Updated Successfully");
            } else {
                // ✅ CREATE API
                await createEnquiryIssue({
                    issueName: issue.trim(),
                    description: description || "", // optional
                }).unwrap();

                toast.success("Issue Added Successfully");
            }

            onClose();
        } catch (err) {
            toast.error(err?.data?.message || "Something went wrong");
        }
    };

    return (
        <div className={styles.popupForm}>
            <div className={styles.header}>
                {/* ✅ DYNAMIC TITLE */}
                <h2 className={styles.tittle}>
                    {editData ? "Edit Issue" : "Add Issue"}
                </h2>
                <span className={styles.closeIcons} onClick={onClose}>
                    X
                </span>
            </div>

            <div className={styles.closeIcon}>
                {/* Issue Name */}
                <div className={styles.inputGroup}>
                    <label className={styles.inputLabel}>
                        Issue Name <span className={styles.required}>*</span>
                    </label>
                    <input
                        className={styles.input}
                        type="text"
                        placeholder="Login issue"
                        value={issue}
                        onChange={(e) => {
                            setIssue(e.target.value);
                            setError("");
                        }}
                    />
                    {error && <span className={styles.error}>{error}</span>}
                </div>

                {/* Description (Optional) */}
                <div className={styles.inputGroup}>
                    <label className={styles.inputLabel}>
                        Description <span className={styles.optional}>(Optional)</span>
                    </label>
                    <textarea
                        className={styles.textarea}
                        placeholder="Describe the issue (optional)"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </div>

                <div className={styles.footerButtons}>
                    <button
                        className={styles.cancel}
                        onClick={onClose}
                        disabled={creating || updating}
                    >
                        Cancel
                    </button>

                    <button
                        className={styles.save}
                        onClick={handleSubmit}
                        disabled={creating || updating}
                    >
                        {creating || updating
                            ? "Saving..."
                            : editData
                                ? "Update"
                                : "Add"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddIssuePopup;


